var AvatarPatch = require("components/avatars/AvatarPatch");

require("avatars/owlvatar.scss")

class Owlvatar extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	getPatchScale(offsets) {
		
		var scale = 1.0;
		if (this.props.maxWidth && offsets["width"] > this.props.maxWidth) {
			scale = this.props.maxWidth / offsets["width"];
		}
		if (this.props.maxHeight && offsets["height"] > this.props.maxHeight) {
			scale = this.props.maxHeight / offsets["height"];
		}
		return scale;
	}

	getPatchOffsets() {
		var patches = _.reject(_.values(this.props.patches), function(p) {
			return p == Owlvatar.NO_PATCH;
		});
		var extraLeft =   _.max(patches.map(function(p) { return p["extra_left"]   || 0 }));
		var extraWidth =  _.max(patches.map(function(p) { return p["extra_right"]  || 0 })) + extraLeft;
		var extraTop =    _.max(patches.map(function(p) { return p["extra_top"]    || 0 }));
		var extraHeight = _.max(patches.map(function(p) { return p["extra_bottom"] || 0 })) + extraTop;
		return {
			left:   AvatarPatch.DEFAULT_LEFT   + extraLeft,
			width:  AvatarPatch.DEFAULT_WIDTH  + extraWidth,
			top:    AvatarPatch.DEFAULT_TOP    + extraTop,
			height: AvatarPatch.DEFAULT_HEIGHT + extraHeight
		}
	}

	render() {
		var patches = [];

		var offsets = this.getPatchOffsets();
		var scale = this.getPatchScale(offsets);

		var outerStyle = {
			position: "relative",
			width: (offsets["width"] * scale) + "px",
			height: (offsets["height"] * scale) + "px"
		}

		if (!this.props.nofloat) {
			outerStyle.float = "left";
		}

		var innerStyle = {
			position: "relative",
			width:  (AvatarPatch.WIDTH * scale) + "px",
			height: (AvatarPatch.HEIGHT * scale) + "px",
			left:   (offsets["left"] * scale) + "px",
			top:    (offsets["top"] * scale) + "px"
		}
		
		if (this.props.patches["wings"]) {
			var handOffsets = this.props.patches["wings"]["offsets"]
			var newHandOffsets = {}
			//cannot modify handoffsets directly, it's a shallow copy
			//of props.patches["wings"]["offsets"], and also will alter
			//props in memory
			_.keys(handOffsets).forEach(function(key) {
				newHandOffsets[key] = handOffsets[key] * scale;
			});
		}
		_.pairs(this.props.patches).forEach(function(patchPair) {
			var patchType = patchPair[0];
			var patch = patchPair[1];
			var patchColor = this.props.colors[patchType];

			if (patch != Owlvatar.NO_PATCH) {
				patches.push(
					<AvatarPatch patch={ patch } color={ patchColor } key={ patchType } 
						offsets={ newHandOffsets } />
				)
			}
		}.bind(this));

		if (this.props.showHonorRays) {
			var honorRayDims = {
				width:  (AvatarPatch.WIDTH * scale) + "px",
				height: (AvatarPatch.HEIGHT * scale) + "px"
			}
			patches.push(
				<img src={ require("owls/honor-rays.png") } key="honorRays"
					style={ honorRayDims } />
			);
		}

		return (
			<div className="owlConstraints" style={ outerStyle }>
				<div className="owlConstraintsInner" style={ innerStyle }>
					{patches}
				</div>
			</div>
		)
	}
};

Owlvatar.NO_PATCH = "no_patch";

Owlvatar.propTypes = StrictPropTypes({
	maxWidth: PropTypes.number,
	maxHeight: PropTypes.number,
	nofloat: PropTypes.bool, // Too many legacy uses depend on it floating

	patches: PropTypes.object.isRequired,
	colors: PropTypes.object,

	showHonorRays: PropTypes.bool,
});

module.exports = Owlvatar;



// WEBPACK FOOTER //
// ./modules/components/avatars/Owlvatar.js